module.exports = __webpack_public_path__ + "img/mask-group-2.bd42c35d.png";